import React, { FunctionComponent, useState } from 'react';
import IconVerified from '../../assets/icons/verified';
import { FlightCard, getIcon } from '@flybits/design-system';
import imageErrorOrganization from 'src/assets/organization.svg';
import './OrganizationListItem.scss';
import { setStoredOrganizationId } from '../../helpers/auth.helper';
import { useHistory } from 'react-router-dom';
import { updateRanking } from 'src/helpers/ranking.helper';

const TRANSPARENT_1X1 = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

type ImageDisplayState = 'primary' | 'fallback' | 'hidden';

interface Props {
  id: string;
  name: string;
  verified: boolean;
  imageUrl: string;
  externalUrl: string;
  style?: any;
}

const OrganizationListItem: FunctionComponent<Props> = (props: Props) => {
  const history = useHistory();
  const { id, name, imageUrl, verified: isVerified, style } = props;

  const hasPrimaryImage = Boolean(imageUrl && imageUrl !== 'https://controltower.flybits.com/');
  const primaryImageSrc = hasPrimaryImage
    ? `${!imageUrl.startsWith('http') ? 'https://controltower.flybits.com/' : ''}${imageUrl}`
    : '';

  const [imageState, setImageState] = useState<ImageDisplayState>(hasPrimaryImage ? 'primary' : 'fallback');

  const getImageSrc = () => {
    switch (imageState) {
      case 'primary':
        return primaryImageSrc;
      case 'fallback':
        return imageErrorOrganization;
      case 'hidden':
        return TRANSPARENT_1X1;
    }
  };

  const handleImageError = () => {
    setImageState((prev) => (prev === 'primary' ? 'fallback' : 'hidden'));
  };

  const DEFAULT_CLASS = 'organizationListItem';
  const WRAPPER_CLASS = `${DEFAULT_CLASS}__wrapper`;
  const BORDER_CLASS = `${DEFAULT_CLASS}__border`;
  const ICON_CLASS = `${DEFAULT_CLASS}__project-icon`;
  const INACTIVE_CLASS = `${DEFAULT_CLASS}__inactive`;
  const VERIFIED_CLASS = `${DEFAULT_CLASS}__verified`;

  const HeaderTitle = () => (
    <>
      {name}
      {isVerified && <IconVerified />}
      <div className="project__id">#{id}</div>
    </>
  );

  const handleOnClick = async () => {
    // if (!isActive) return;
    try {
      await setStoredOrganizationId(id);
      updateRanking('organizations', id);
      history.push('/organization/' + id);
    } catch (error) {
      console.error(error);
    }
  };
  const handleKeyDown = (func: any) => (e: any) => {
    switch (e.key) {
      case ' ':
      case 'SpaceBar':
      case 'Enter':
        e.preventDefault();
        func();
        break;
      default:
        break;
    }
  };

  return (
    <div
      className={WRAPPER_CLASS}
      key={id}
      style={style}
      tabIndex={0}
      role="button"
      onKeyDown={handleKeyDown(handleOnClick)}
    >
      <FlightCard
        onClick={handleOnClick}
        className={`${BORDER_CLASS} ${!isVerified ? INACTIVE_CLASS : ''} ${!isVerified ? VERIFIED_CLASS : ''}`}
        header={<HeaderTitle />}
        image={
          <img
            src={getImageSrc()}
            width="40"
            className={ICON_CLASS}
            onError={handleImageError}
            alt={`Image for: ${name}`}
            style={imageState === 'hidden' ? { visibility: 'hidden' } : undefined}
            aria-hidden={imageState === 'hidden'}
          />
        }
        actionables={
          <>
            <div className="card__icon">{getIcon('baselineArrowRight', {})}</div>
          </>
        }
      />
    </div>
  );
};

export default OrganizationListItem;
